import settings from '@/settings'

let listar = headers => {
  return fetch(`${settings.apetrusApi}/meios-de-pagamento/`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

let porPosto = (headers, posto) => {
  return fetch(
    `${settings.apetrusApi}/meios-de-pagamento/?posto=${posto}&listar_tudo=true`,
    {
      method: 'GET',
      mode: 'cors',
      headers: headers
    }
  )
}

let secundarioPorPosto = (headers, posto) => {
  return fetch(
    `${settings.apetrusApi}/meios-de-pagamento/meios_recebimentos_secundarios/?posto=${posto}&listar_tudo=true`,
    {
      method: 'GET',
      mode: 'cors',
      headers: headers
    }
  )
}

let vincularPagamento = (headers, pagamento, data) => {
  return fetch(
    `${settings.apetrusApi}/meios-de-pagamento/${pagamento}/vincular-posto/`,
    {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(data)
    }
  )
}

let desvincularPagamento = (headers, pagamento, data) => {
  return fetch(
    `${settings.apetrusApi}/meios-de-pagamento/${pagamento}/desvincular-posto/`,
    {
      method: 'PUT',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(data)
    }
  )
}

let ativarPagamento = (headers, pagamento, data, deletar) => {
  return fetch(
    `${settings.apetrusApi}/meios-de-pagamento/${pagamento}/tornar-principal-tipo-pagamento/?deletar=${deletar}`,
    {
      method: 'PUT',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(data)
    }
  )
}

let habilitarPagamento = (headers, pagamento) => {
  return fetch(
    `${settings.apetrusApi}/formaspagamento/habilitarformapagamento/?id_forma_pagamento=${pagamento}`,
    {
      method: 'PATCH',
      mode: 'cors',
      headers: headers
    }
  )
}

const atualizar = (headers, data) => {
  return fetch(
    `${settings.apetrusApi}/meios-de-pagamento/${data.id}/atualizar/`,
    {
      method: 'PUT',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(data)
    }
  )
}

export default {
  listar,
  porPosto,
  secundarioPorPosto,
  vincularPagamento,
  desvincularPagamento,
  ativarPagamento,
  habilitarPagamento,
  atualizar
}
